import React from 'react';
import type { NextPage } from 'next';
import Head from 'next/head';

import { Cookies as CookiesView } from 'components/views/Cookies';

const Cookies: NextPage = () => (
  <>
    <Head>
      <title>Cookies - Blipp</title>
      <meta property="og:title" content="Cookies - Blipp" />
      <meta
        property="og:description"
        content="En cookie är en liten textfil som lagras på din dator eller mobila enhet när du besöker en webbplats. Läs om vår cookiepolicy här!"
      />
      <meta
        name="description"
        content="En cookie är en liten textfil som lagras på din dator eller mobila enhet när du besöker en webbplats. Läs om vår cookiepolicy här!"
      />
    </Head>
    <CookiesView />
  </>
);

export default Cookies;
